module.exports = __webpack_public_path__ + "img/linkedin.a1557e16.svg";